import React from 'react';
import Card from './Card';

interface KpiCardProps {
  label: string;
  value: number | string;
  color: string;
  icon: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ label, value, color, icon }) => (
  <div className="col-md-4 col-lg-2">
    <Card className="text-center" bodyClassName="py-3" style={{ borderTop: `3px solid var(--bs-${color})` }}>
      <i className={`fa ${icon} fa-2x text-${color} mb-2`}></i>
      <h3 className="mb-0">{value}</h3>
      <small className="text-muted">{label}</small>
    </Card>
  </div>
);

export default KpiCard;
